export const bossDifficulties = {
  Zakum: ['Easy', 'Normal', 'Chaos'],
  Horntail: ['Easy', 'Normal', 'Chaos'],
  Hilla: ['Normal', 'Hard'],
  Cygnus: ['Easy', 'Normal'],
  Magnus: ['Easy', 'Normal', 'Hard'],
  'Pink Bean': ['Normal', 'Chaos'],
  Papulatus: ['Normal', 'Chaos'],
  'Crimson Queen': ['Normal', 'Chaos'],
  'Von Bon': ['Normal', 'Chaos'],
  Pierre: ['Normal', 'Chaos'],
  Vellum: ['Normal', 'Chaos'],
  Lotus: ['Normal', 'Hard', 'Extreme'],
  Damien: ['Hard', 'Hard'],
  'Guardian Angel Slime': ['Normal', 'Chaos'],
  Lucid: ['Easy', 'Normal', 'Hard'],
  Will: ['Easy', 'Normal', 'Hard'],
  Gloom: ['Normal', 'Chaos'],
  Darknell: ['Normal', 'Hard'],
  'Verus Hilla': ['Normal', 'Hard'],
  'Black Mage': ['Hard', 'Extreme'],
  Seren: ['Normal', 'Hard', 'Extreme'],
  Kalos: ['Easy', 'Normal', 'Chaos', 'Extreme'],
  Kaling: ['Easy', 'Normal', 'Hard', 'Extreme'],
};
